import { render } from "./CCrestartRecordList.vue?vue&type=template&id=b0a99bbe&scoped=true"
import script from "./CCrestartRecordList.vue?vue&type=script&lang=js"
export * from "./CCrestartRecordList.vue?vue&type=script&lang=js"

import "./CCrestartRecordList.vue?vue&type=style&index=0&id=b0a99bbe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b0a99bbe"

export default script